import { Component, OnInit } from "@angular/core";

@Component({
    selector: "dodo-cta-button-group-data-plans",
    templateUrl: "./cta-button-group-data-plans.component.html",
    styleUrls: ["./cta-button-group-data-plans.component.scss"],
    standalone: false
})
export class CtaButtonGroupDataPlansComponent implements OnInit {
	stepTitle = "All plans include";
	constructor() {}

	ngOnInit(): void {}
}
